import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FaArrowRight } from 'react-icons/fa';

const Products = () => {
  const fadeIn = {
    hidden: { opacity: 0 },
    visible: { 
      opacity: 1,
      transition: { duration: 0.6 }
    }
  };

  const categories = [
    {
      id: 'pediatrics',
      name: 'Pediatrics',
      description: 'Specialized healthcare solutions for infants, children, and adolescents.',
      count: 15,
      color: 'pediatric',
      image: 'https://placehold.co/300x200/3B82F6/FFFFFF?text=Pediatrics&font=montserrat'
    },
    {
      id: 'gynecology',
      name: 'Gynecology',
      description: 'Comprehensive women\'s health products addressing reproductive wellness.',
      count: 11,
      color: 'gynecology',
      image: 'https://placehold.co/300x200/EC4899/FFFFFF?text=Gynecology&font=montserrat'
    },
    {
      id: 'orthopedics',
      name: 'Orthopedics',
      description: 'Solutions for bone, joint, and muscle health to improve mobility and strength.',
      count: 12,
      color: 'orthopedic',
      image: 'https://placehold.co/300x200/F59E0B/FFFFFF?text=Orthopedics&font=montserrat'
    }
  ];

  return (
    <div className="pt-20">
      <div className="bg-primary text-white py-20">
        <div className="container-custom">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="max-w-3xl"
          >
            <h1 className="text-4xl md:text-5xl font-bold mb-6">Our Product Categories</h1>
            <p className="text-xl text-gray-100 mb-8">
              Migliore Life Sciences offers a comprehensive range of pharmaceutical products
              across three specialized medical segments.
            </p>
          </motion.div>
        </div>
      </div>

      <div className="container-custom py-20">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          {categories.map((category, index) => (
            <motion.div
              key={category.id}
              variants={fadeIn}
              initial="hidden"
              animate="visible"
              transition={{ delay: index * 0.2 }}
              className="bg-white rounded-lg overflow-hidden shadow-lg hover:shadow-xl transition-all duration-300 flex flex-col"
            >
              <div className={`h-48 w-full bg-${category.color} flex items-center justify-center p-4`}>
                <img 
                  src={category.image} 
                  alt={`${category.name} category illustration`}
                  className="max-h-full w-auto object-contain rounded-md shadow-sm"
                />
              </div>
              <div className="p-6 flex-grow flex flex-col">
                <h3 className="text-xl font-bold mb-3">{category.name}</h3>
                <p className="text-gray-600 mb-4">
                  {category.description}
                </p>
                <div className="flex justify-between items-center">
                  <span className={`text-sm font-medium text-${category.color}`}>
                    {category.count} Products
                  </span>
                  <Link 
                    to={`/products/${category.id}`} 
                    className={`inline-flex items-center text-${category.color} font-medium hover:underline group`}
                  >
                    View Products <FaArrowRight className="ml-2 transform group-hover:translate-x-1 transition-transform" />
                  </Link>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Products;
